<script setup lang="ts">
import { cloneDeep } from 'lodash'
import { VNode } from 'vue'

import { AttackErrorAttribute } from '@collector/sportsapi-client-legacy'
import { useIncidentGroupComponents } from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/composables/useIncidentGroupComponents'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import FieldZonesModal from '../components/FieldZonesModal/FieldZonesModal.vue'
import { filterAttributesBasedOnSelectedZone } from '../components/FieldZonesModal/utils'
import { GroupName, groups } from './consts'
import { zones } from './consts/zones'

interface Props {
  linkedIncident: ProbableLinkedIncident
}
const props = defineProps<Props>()

// emits
const emit = defineEmits(['close'])

// data
const localLinkedIncident = cloneDeep(props.linkedIncident)

// composables
const incidentGroupComponentsComposable = useIncidentGroupComponents(
  localLinkedIncident,
  groups,
)
const { updateIncident: _updateIncident, selectedAttributes } =
  incidentGroupComponentsComposable

// methods
function getGroupComponent(name: GroupName): VNode | null {
  return incidentGroupComponentsComposable.getGroupComponent(groups.get(name)!)
}

function updateIncident(data: { selectedZone: number | null }): void {
  const attributes = filterAttributesBasedOnSelectedZone(
    selectedAttributes.value as AttackErrorAttribute[],
    zones,
    data.selectedZone,
  )

  _updateIncident({
    attribute_ids: attributes,
  })

  emit('close')
}
</script>

<template>
  <FieldZonesModal
    :linkedIncident
    :zones
    :incidentParticipantTeamSide="linkedIncident.side!"
    @save="updateIncident"
    @close="$emit('close')"
  >
    <component :is="getGroupComponent(GroupName.ErrorType)" />
  </FieldZonesModal>
</template>
